exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-success{\r\n    background-color: green;\r\n}\r\n\r\n.bg-warning{\r\n    background-color: orange;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/cssd/cssd.component.css
// module id = ../../../../../src/app/cssd/cssd.component.css
// module chunks = main